export default "__VITE_ASSET__DWOxGcXi__"